(function (){
    'use strict';

    angular
        .module('adm', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            '720kb.tooltips'
        ]);
})();